/**
 * Preview + inspector share these CTA fallbacks on the canvas when stored
 * text is empty. Inspector inputs must bind the live string (including "")
 * and use these as `placeholder` / blur-restore only — never as a controlled
 * `value` coerce, or backspace cannot clear the field.
 */
/** Empty by default — creators set button copy when Show button is on. */
export const BANNER_CTA_DEFAULT = "";
/** Input hint only — never written as the stored CTA. */
export const BANNER_CTA_PLACEHOLDER = "e.g. Shop Now";
export const HIGHLIGHT_CTA_DEFAULT = "Check it out!";
export const PODCAST_CTA_DEFAULT = "Listen Now";
/** Keep in sync with `DEFAULT_CAMPAIGN_BUTTON_TEXT` (campaign bootstrap). */
export const CAMPAIGN_BUTTON_DEFAULT = "Subscribe";
export const SCHEMA_CTA_LABEL_DEFAULT = "Button";
/** Synthetic / unbound banner slot while the row is still seeding. */
export const BANNER_SLOT_CTA_DEFAULT = "Learn more";

/**
 * Controlled input value for CTA / button-label fields.
 * Preserves explicit empty so the user can backspace everything and type new
 * text. Pass `fallback` only for call-site clarity — apply it via placeholder
 * or on blur/save, not here.
 */
export function ctaInputValue(
  live: unknown,
  _fallback?: string,
): string {
  return String(live ?? "");
}
